import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTwitch,
  FaEnvelope,
} from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import FormattedMessage from '../FormattedMessage/FormattedMessage'
import AMDSvgLogo from '../Logo/AMDSvgLogo'

import './FooterV2.scss'

class FooterV2 extends React.Component {
  // Handler for cookie settings button
  handleCookieSettings = e => {
    e.preventDefault()
    // If OneTrust is loaded, open the settings UI
    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  render() {
    const { location } = this.props

    if (location.pathname === '/oauth/steam' || location.pathname === '/epic-redirect') {
      return null
    }

    // Social media links with proper accessibility
    const socialLinks = [
      {
        url: 'https://www.facebook.com/amd',
        icon: FaFacebookF,
        label: 'AMD on Facebook',
      },
      {
        url: 'https://www.instagram.com/amd',
        icon: FaInstagram,
        label: 'AMD on Instagram',
      },
      {
        url: 'https://www.linkedin.com/company/amd',
        icon: FaLinkedinIn,
        label: 'AMD on LinkedIn',
      },
      {
        url: 'https://www.twitch.tv/amd',
        icon: FaTwitch,
        label: 'AMD on Twitch',
      },
      {
        url: 'https://twitter.com/amd',
        icon: FaXTwitter,
        label: 'AMD on Twitter',
      },
      {
        url: 'https://www.youtube.com/user/amd?sub_confirmation=1',
        icon: FaYoutube,
        label: 'AMD on YouTube',
      },
      {
        url: 'https://www.amd.com/en/corporate/subscriptions',
        icon: FaEnvelope,
        label: 'AMD Email Subscriptions',
      },
    ]

    // Footer menu links with proper attributes
    const footerLinks = [
      {
        url: 'https://www.amd.com/en/legal/copyright.html',
        messageId: 'footer.links.terms',
      },
      {
        url: 'https://www.amd.com/en/legal/privacy.html',
        messageId: 'footer.links.privacy',
      },
      {
        url: 'https://www.amd.com/en/legal/trademarks.html',
        messageId: 'footer.links.trademark',
      },
      {
        url: 'https://www.amd.com/content/dam/amd/en/documents/corporate/cr/supply-chain-transparency.pdf',
        messageId: 'footer.links.statementonforcedlabor',
      },
      {
        url: 'https://www.amd.com/en/legal/competition.html',
        messageId: 'footer.links.fairopencompetition',
      },
      {
        url: 'https://www.amd.com/system/files/documents/amd-uk-tax-strategy.pdf',
        messageId: 'footer.links.uktaxstrategy',
      },
      {
        url: 'https://www.amd.com/en/legal/cookies.html',
        messageId: 'footer.links.cookie',
      },
    ]

    return (
      <footer className="footer bg-dark" role="contentinfo" aria-label="Site footer">
        <div className="container">
          <section className="footer-top-section">
            <div className="row d-flex">
              <div className="col-xl-5 footer-top-section-logo">
                <div className="navbar-brand">
                  <a
                    href="https://www.amd.com/en"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="AMD main website (opens in a new tab)"
                  >
                    <AMDSvgLogo className="navbar-brand-image" alt="AMD" />
                  </a>
                  <NavLink to="/" aria-label="AMD Rewards home">
                    <span className="navbar-brand-text">Rewards</span>
                  </NavLink>
                </div>
              </div>
              <div className="col-xl-7 text-center">
                <nav aria-label="Social media links">
                  <ul className="social-menu">
                    {socialLinks.map((link, index) => (
                      <li className="social-menu-item" key={index}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={link.label}
                        >
                          <link.icon className="social-menu-icon" aria-hidden="true" />
                          <span className="sr-only">{link.label}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </section>
          <section className="footer-bottom-section">
            <div className="row d-flex align-items-center">
              <div className="col-12 text-center">
                <nav aria-label="Footer links">
                  <ul className="footer-bottom-menu">
                    {footerLinks.map((link, index) => (
                      <li className="footer-bottom-menu-item" key={index}>
                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                          <FormattedMessage id={link.messageId} />
                        </a>
                      </li>
                    ))}
                    <li className="footer-bottom-menu-item">
                      <button
                        type="button"
                        id="ot-sdk-btn"
                        className="ot-sdk-show-settings footer-link__cookie-settings"
                        onClick={this.handleCookieSettings}
                      >
                        <FormattedMessage id="footer.links.cookiesettings" />
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="row d-flex align-items-center">
              <div className="col-12 text-center">
                <span className="footer-copyright">
                  <FormattedMessage id="footer.copyright.bottom" />
                </span>
              </div>
            </div>
          </section>
        </div>
      </footer>
    )
  }
}

FooterV2.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
}

export default withRouter(FooterV2)
